<template>
    <el-aside width="236px">
        <el-menu
            mode="vertical"
            @select="navigate"
            :default-active="currentUrl"
            :default-openeds="['/ranking', '/acceptance-list', '/weekly-procedures']"
            text-color="#666"
            active-text-color="#444"
            class="main-menu"
        >
            <!-- <el-menu-item index="/">
                Home
            </el-menu-item> -->

            <el-menu-item index="/players" class="weight600">
                <template slot="title">
                    <i class="el-icon-user"></i>
                    <span>Players</span>
                </template>
            </el-menu-item>

            <el-menu-item index="/tournaments" class="weight600">
                <template slot="title">
                    <i class="el-icon-trophy-1"></i>
                    <span>Tournaments</span>
                </template>
            </el-menu-item>

            <el-divider></el-divider>

            <el-submenu index="/ranking">
                <template slot="title">
                    <i class="el-icon-medal-1"></i>
                    <span>Show Ranking</span>
                </template>
                <el-menu-item index="/ranking/current">Current Ranking</el-menu-item>
                <el-menu-item index="/ranking/by-date">Ranking History</el-menu-item>
                <el-menu-item index="/ranking/summaries">Ranking Summaries</el-menu-item>
                <el-menu-item index="/ranking/special-ranking">Special Rankings</el-menu-item>
            </el-submenu>

            <el-divider></el-divider>

            <el-submenu index="/acceptance-list">
                <template slot="title">
                    <i class="el-icon-notebook-2"></i>
                    <span>Acceptance list</span>
                </template>

                <el-menu-item index="/acceptance-list">Show by tournament</el-menu-item>

                <el-menu-item index="/acceptance-list/procedures">
                    Execute procedures
                    <span class="spacer"></span>
                    <i class="el-icon-loading" v-if="runningProcedure"></i>
                </el-menu-item>
            </el-submenu>

            <el-divider></el-divider>

            <el-submenu index="/weekly-procedures">
                <template slot="title">
                    <i class="el-icon-wind-power"></i>
                    <span>Calc Ranking</span>
                    <span class="spacer"></span>
                    <i class="el-icon-loading" v-if="runningWeeklyProcedure"></i>
                </template>
                <el-menu-item index="/ranking-procedures">Weekly Procedures</el-menu-item>
                <el-menu-item index="/ranking/required-tournaments">Required Tournaments</el-menu-item>
                <el-menu-item index="/ranking/corona">Better of Ranking</el-menu-item>
            </el-submenu>

            <el-divider></el-divider>

            <el-menu-item index="/sys-codes" class="weight600">
                <template slot="title">
                    <i class="el-icon-set-up"></i>
                    <span>System Table</span>
                </template>
            </el-menu-item>

            <el-menu-item index="/tournament-prizes" class="weight600">
                <template slot="title">
                    <i class="el-icon-coin"></i>
                    <span>Tournament Prizes</span>
                </template>
            </el-menu-item>

            <el-menu-item index="/tournament-points" class="weight600">
                <template slot="title">
                    <i class="el-icon-medal-1"></i>
                    <span>Tournament Points</span>
                </template>
            </el-menu-item>

            <el-menu-item index="/wta-tour-years" class="weight600">
                <template slot="title">
                    <i class="el-icon-date"></i>
                    <span>WTA Tour Years</span>
                </template>
            </el-menu-item>

            <el-menu-item index="/wta-system" class="weight600">
                <template slot="title">
                    <i class="el-icon-setting"></i>
                    <span>WTA System</span>
                </template>
            </el-menu-item>
        </el-menu>
    </el-aside>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('rankingProcedure', ['runningRankingProcedure']),
        ...mapGetters('tournamentRounds', ['runningTournRoundSplit']),
        ...mapGetters('playerStats', ['runningUpdateYtdTotals']),
        ...mapGetters('procedure', ['runningProcedure']),
        runningWeeklyProcedure() {
            return this.runningRankingProcedure || this.runningUpdateYtdTotals || this.runningTournRoundSplit;
        },
    },
    data() {
        return {
            currentUrl: this.$route.path,
        };
    },
    methods: {
        navigate(url) {
            this.$router.push(url).catch((error) => {});
        },
    },
};
</script>

<style lang="scss">
.main-menu {
    padding-top: 8px;
}

.el-menu {
    border-right: none !important;
}

.el-menu-item {
    font-size: 16px;
    display: flex;
    align-items: center;

    &.is-active {
        background-color: rgba(0, 0, 0, 0.2) !important;
    }
}

.el-submenu__title {
    font-weight: 600;
}

.el-divider--horizontal {
    margin: 16px 0 !important;
}
</style>
